import { useQuery } from 'react-query';

import { getTaskDataByHashCode as queryFn } from 'api/endPoints/getTaskDataByHashCode';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTaskDataByHashCode = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTaskDataByHashCode', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId) && Boolean(params.hashCodesList && params.hashCodesList.length > 0),
        staleTime: 0,
        cacheTime: 0,
    });
};

export interface QueryParams {
    metaDataId: number;
    hashCodesList?: string[];
    filter?: string;
}

export interface QueryFnResponse {
    activityId: string;
    metaDataId: number;
    name: string;
    taskId: number;
    taskVersionHashCode: string;
}

export type QueryResponse = QueryFnResponse & {};
